import type { ReactNode } from "react";
import { AdSlot } from "@/components/ads/AdSlot";
import { ADSENSE_NATIVE_LAYOUT_KEY, ADSENSE_SLOTS } from "@/components/ads/slots";

// Tunable in one place so StickerGrid (page 1, SSR) and LoadMoreClient
// (pages 2..N, client-appended) stay consistent.
//
// IN_GRID_EVERY_N=4 keeps the ad-to-content ratio under AdSense's "ads
// should not exceed content" threshold once infinite scroll spans dozens
// of cards. The cap protects long sessions from triggering policy flags.
export const IN_GRID_EVERY_N = 4;
export const IN_GRID_MAX_PER_PAGE = 10;

export function shouldInsertInGridAdAfter(positionWithinPage: number, alreadyInserted: number) {
  return alreadyInserted < IN_GRID_MAX_PER_PAGE && (positionWithinPage + 1) % IN_GRID_EVERY_N === 0;
}

// Count how many in-grid ads a record list of length `n` would produce
// before applying the cap. LoadMoreClient uses this to seed its running
// counter from StickerGrid's first-page render.
export function inGridAdsForRecordCount(n: number) {
  return Math.floor(n / IN_GRID_EVERY_N);
}

export function inGridAdNode(key: string): ReactNode {
  return (
    <AdSlot
      key={key}
      slot={ADSENSE_SLOTS.grid}
      format="fluid"
      layoutKey={ADSENSE_NATIVE_LAYOUT_KEY}
      className="rounded-card min-h-30 w-full bg-white shadow-(--shadow-card)"
    />
  );
}
